import React, { Fragment, useEffect } from 'react';

import Heading from '@atlaskit/heading';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box } from '@atlaskit/primitives/compiled';
import { ReactRenderer, type RendererProps } from '@atlaskit/renderer';
import Spinner from '@atlaskit/spinner';
import { type Chat } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { useQuery } from '@atlassian/conversation-assistant-service/common/utils/use-query';
import {
	type AssistanceServiceInjectedParams,
	createHookWithAssistanceService,
} from '@atlassian/conversation-assistant-service/services/assistance-service/main';
import { EMPTY_CONVERSATION_ID } from '@atlassian/conversation-assistant-store/controllers/chat';

import { useAssistanceServiceParams } from '../../../common/utils/use-assistance-service-params';
import { useConversation } from '../../../controllers/conversation/useConversation';
/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */
const stringify = (obj: Object): string => {
	try {
		return JSON.stringify(obj, null, 2);
	} catch (e) {
		return 'Error parsing JSON object';
	}
};

/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */
const createAdfDocument = (codeContent: Object): RendererProps['document'] =>
	({
		version: 1,
		type: 'doc',

		content: [
			{
				type: 'codeBlock',
				attrs: {
					language: 'json',
				},
				content: [
					{
						type: 'text',
						text: stringify(codeContent),
					},
				],
			},
		],
	}) as RendererProps['document']; // TODO: Fix this casting

/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */
const HeadingTitle = ({ title }: { title: string }) => (
	<Box paddingBlockStart="space.400">
		<Heading as="h2" size="medium">
			{title}
		</Heading>
	</Box>
);

/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */
const useDebugLogs = createHookWithAssistanceService(
	({ assistanceServiceInjectedParams: { assistanceService } }: AssistanceServiceInjectedParams) => {
		const { conversation } = useConversation();

		const { data, error, isFetching, refetch } = useQuery({
			queryKey: ['debugLogs', conversation?.id ?? ''],
			queryFn: async (): Promise<Chat> => {
				const response = await assistanceService.getConversationDebugLogs(conversation?.id ?? '');
				return response;
			},
			enabled: false,
		});

		useEffect(() => {
			if (conversation?.id !== EMPTY_CONVERSATION_ID) {
				refetch();
			}
		}, [conversation?.id, refetch]);

		return {
			data,
			error,
			isFetching,
		};
	},
);

/**
 * @deprecated Remove on FG graphyte_rovo_debug_enhancement clean up
 */
export const DebugModalContents = (): React.JSX.Element => {
	const assistanceServiceParams = useAssistanceServiceParams({
		touchpointSource: 'debug-modal-contents',
	});

	const {
		data: messages,
		error: debugLogError,
		isFetching: isDebugFetching,
	} = useDebugLogs({
		assistanceServiceParams,
	});

	const renderDebugLogs = () => {
		if (debugLogError) {
			return (
				<Box>
					<code>Failed to fetch chat list: </code>
					{debugLogError.message}
				</Box>
			);
		}

		if (isDebugFetching) {
			return <Spinner />;
		}

		return <ReactRenderer document={createAdfDocument(messages ?? [])} allowCopyToClipboard />;
	};

	return (
		<Fragment>
			<HeadingTitle title="Chat List" />
			{renderDebugLogs()}
		</Fragment>
	);
};
